module.exports = __webpack_public_path__ + "img/building.c3c4fafd.svg";